import React from 'react';
import { Establishment } from '../EstablishmentTypes';
import { EnhancedEstablishmentCell, DateCell, NafCodeCell, SizeCell } from './TableCells';
import { useTableUtils } from './useTableUtils';

interface StandardEstablishmentRowProps {
  establishment: Establishment;
  utils: ReturnType<typeof useTableUtils>;
}

export const StandardEstablishmentRow: React.FC<StandardEstablishmentRowProps> = ({ 
  establishment, 
  utils 
}) => (
  <>
    <EnhancedEstablishmentCell 
      establishment={establishment} 
      copyToClipboard={utils.copyToClipboard} 
      openGoogleSearch={utils.openGoogleSearch}
    />
    <DateCell date={establishment.creationDate} />
    <NafCodeCell nafCode={establishment.nafCode} getNafCodeLabel={utils.getNafCodeLabel} />
    <SizeCell trancheEffectifs={establishment.trancheEffectifs} categorieEntreprise={establishment.categorieEntreprise} />
  </>
); 